"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GearSolid: function() {
        return GearSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const GearSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.0001 1C9.56969 1 9.18755 1.27543 9.05143 1.68377L8.46093 3.45529L6.79091 2.62028C6.40592 2.42778 5.94095 2.50324 5.63659 2.8076L2.80816 5.63602C2.5038 5.94038 2.42835 6.40535 2.62084 6.79034L3.45602 8.4607L1.68377 9.05144C1.27543 9.18756 1 9.5697 1 10.0001V14.0001C1 14.4306 1.27543 14.8127 1.68377 14.9488L3.4559 15.5395L2.62096 17.2094C2.42847 17.5944 2.50392 18.0594 2.80828 18.3637L5.63671 21.1921C5.94107 21.4965 6.40604 21.572 6.79103 21.3795L8.46079 20.5446L9.05133 22.3162C9.18745 22.7245 9.56958 23 10 23H14C14.4304 23 14.8126 22.7245 14.9487 22.3162L15.5392 20.5447L17.2094 21.3798C17.5944 21.5723 18.0594 21.4968 18.3637 21.1924L21.1921 18.364C21.4965 18.0597 21.572 17.5947 21.3795 17.2097L20.5444 15.5396L22.3164 14.9489C22.7248 14.8128 23.0002 14.4307 23.0002 14.0002V10.0002C23.0002 9.5698 22.7248 9.18766 22.3164 9.05155L20.5453 8.46117L21.3807 6.79042C21.5732 6.40543 21.4977 5.94046 21.1934 5.6361L18.365 2.80767C18.0606 2.50331 17.5956 2.42786 17.2106 2.62035L15.5395 3.45591L14.9488 1.68377C14.8127 1.27543 14.4305 1 14.0001 1H10.0001ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
        fill: "currentColor"
    })
}), "GearSolid");
const _default = GearSolid;
